module.exports = __webpack_public_path__ + "img/relogio-feel.eb2d4a93.jpg";